<template>
  <div class="list-container">
    <ul>
      <li v-for="item in list" :key="item">
        <div>
          <img v-if="type == 2" src="@/assets/home/icon02_ixdex.png" />
          <img v-else src="@/assets/home/icon01_ixdex.png" />
        </div>
        <!-- <div> -->
        <span :class="{'white-color':type == 2}">{{item}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["list", "type"]
};
</script>
<style lang="less" scoped>
li {
  margin-bottom: 20px;
  display: flex;
  align-items: top;
  img,
  span {
    // display: inline-block;
    vertical-align: middle;
  }
  span {
    line-height: 30px;
    margin-left: 10px;
    display: inline-block;
  }

  .white-color {
    color: #ffffff;
  }
}
</style>
